import { State } from "../index";
import { userRoles } from "../../constants";
/**
 * Indicates whether the ui state is ready to be rendered
 */
export const isReady = (state: State) => state.app.isReady;

/**
 * Checks if the user is authenticated
 */
export const isAuthenticated = (state: State) => state.app.authenticated;

/**
 * Checks if the user is an admin user
 */
export const isAdmin = (state: State) =>
	state.app.roles.hasOwnProperty(userRoles.ADMIN);

/**
 * Checks if the user is a workflow designer
 */
export const isWorkflowDesigner = (state: State) =>
	state.app.roles.hasOwnProperty(userRoles.WORKFLOW_DESIGNER);

/**
 * Checks if the user is a form designer
 */
export const isFormDesigner = (state: State) =>
	state.app.roles.hasOwnProperty(userRoles.FORM_DESIGNER);

/**
 * Checks if the user is a manager
 */
export const isManager = (state: State) =>
	Object.keys(state.app.managedRoles).length > 0;

/**
 * Get notifications unread count from state
 */
export const getNotifUnread = (state: State) => state.app.notifUnread;

/**
 * Gets state of the alerts array
 */
export const getAlerts = (state: State) => state.app.alerts;

export const getAuthType = (state: State) => state.app.authType;

export const getAuthClientId = (state: State) => state.app.clientId;

export const getUsername = (state: State) => state.app.username;

export const getRoles = (state: State) => state.app.roles;

export const getManagedRoles = (state: State) => state.app.managedRoles;

export const getLegacyCheckboxes = (state: State) => state.app.legacyCheckboxes;

export const getCheckedBoxes = (state: State) => state.app.listCheckboxes;

export const getFormFullWidth = (state: State) => state.app.formFullWidth;
